import type { ComboboxItem } from '@mantine/core';
import { Text } from '@mantine/core';

type RenderOptionInput = { option: ComboboxItem; checked: boolean };

export const renderOption = ({ option }: RenderOptionInput) => (
  <Text data-testid={option.label} size="md" fw={500}>
    {option.label}
  </Text>
);
